module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "game-template"
  }, [(_vm.game) ? _c('ul', {
    staticClass: "players"
  }, _vm._l((_vm.game.players), function(player, playerID) {
    return _c('li', {
      staticClass: "player"
    }, [_c('div', {
      staticClass: "player-stats",
      class: {
        'player-stats--gameover': _vm.gameOver
      }
    }, [_c('div', {
      staticClass: "player-stats-top"
    }, [_c('p', {
      staticClass: "player-name"
    }, [_vm._v(_vm._s(player.name))]), _vm._v(" "), _c('p', {
      staticClass: "player-score",
      style: ({
        'color': player.color
      })
    }, [_vm._v("\n            " + _vm._s(_vm.currentScores && _vm.currentScores[playerID] ? _vm.currentScores[playerID].total : 0) + "\n          ")])]), _vm._v(" "), _c('div', {
      staticClass: "score-progress",
      style: ({
        'background-color': player.color,
        'width': _vm.getScorePercent(_vm.currentScores && _vm.currentScores[playerID] ? _vm.currentScores[playerID].total : 0) + '%'
      })
    }), _vm._v(" "), _c('div', {
      staticClass: "player-stats-bottom"
    }, _vm._l((_vm.game.rounds), function(round, id) {
      return (_vm.game.rounds) ? _c('p', {
        staticClass: "player-score-previous",
        class: {
          'player-score-previous--yaniv': _vm.scores[id][playerID].yaniv && !_vm.scores[id][playerID].contre,
            'player-score-previous--contre': _vm.scores[id][playerID].contre,
            'player-score-previous--douche': _vm.scores[id][playerID].douche
        }
      }, [_c('span', {
        staticClass: "player-score-previous_point",
        style: (_vm.scores[id][playerID].yaniv && !_vm.scores[id][playerID].contre ? {
          'background-color': player.color
        } : {})
      }, [_vm._v("\n              " + _vm._s(round[playerID]) + "\n            ")]), _vm._v(" "), _c('span', {
        staticClass: "player-score-previous_score",
        style: ({
          'color': player.color,
          'text-decoration': 'none'
        })
      }, [_vm._v("\n              " + _vm._s(_vm.scores[id][playerID].total) + "\n            ")])]) : _vm._e()
    }))]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.gameOver),
        expression: "!gameOver"
      }],
      staticClass: "button-yaniv ripple circle",
      style: ({
        'background-color': player.color
      }),
      on: {
        "click": function($event) {
          _vm.editScore(playerID)
        }
      }
    }, [_vm._v("YANIV!")])])
  })) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6b25883f!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Game.vue
// module id = 113
// module chunks = 2